module.exports = __webpack_public_path__ + "static/media/person-icon-active.6eadf5d6.svg";